import ApiClient from 'api/ApiClient'

class MaterialBrandsApi extends ApiClient {
  constructor() {
    super({url:'material_brands'})
  }
}

export default MaterialBrandsApi
